import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Manifesto from "../components/Manifesto";
import FeaturedProduct from "../components/FeaturedProduct";
import Collections from "../components/Collections";
import Features from "../components/Features";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";

export default function Home() {
  const collectionsRef = useRef(null);
  const location = useLocation();
  const scrollHandled = useRef(false);

  // Handle cross-page anchor navigation (e.g. clicking "Collections" from a product page)
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target || scrollHandled.current) return;
    scrollHandled.current = true;
    let count = 0;
    const tick = () => {
      const el = document.getElementById(target);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80;
        if (window.__lenis) {
          window.__lenis.resize();
          window.__lenis.scrollTo(y, { duration: 1.0 });
        } else {
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
      if (++count >= 8) clearInterval(iv);
    };
    const iv = setInterval(tick, 200);
    tick();
    return () => clearInterval(iv);
  }, [location.state]);

  const scrollToCollections = () => {
    const el = document.getElementById("collections");
    if (el) {
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
      else el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-[#050505] grain" data-testid="home">
      <Navbar />
      <Hero onShop={scrollToCollections} />
      <EditorialMarquee />
      <Manifesto />
      <FeaturedProduct />
      <Collections ref={collectionsRef} />
      <Features />
      <Newsletter />
      <Footer />
    </div>
  );
}
